import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTableDynamic from "../../../../component/Table/DataTableDynamic";

const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

const ReportGeneralLedger = () => {

    const [keys, setKeys] = useState([]);
    const [columns, setColumns] = useState([]);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_REPORT = "api/erpppsu/report/GeneralLedger";

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [filterFirstDate, setFilterFirstDate] = useState(getTodayDate());
    const [filterLastDate, setFilterLastDate] = useState(getTodayDate());

    const [expandedAccounts, setExpandedAccounts] = useState({});
    const [transactions, setTransactions] = useState({});

    const fetchData = async (url) => {
        setLoading(true);
        setError(null);
        try {
            const res = await axios.get(url);
            return res.data;
        } catch (err) {
            console.error(err);
            setError("Failed to fetch data.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleFilter();
    }, []);

    useEffect(() => {
        const firstKey = Object.keys(transactions)[0];
        if (firstKey && Array.isArray(transactions[firstKey]) && transactions[firstKey].length > 0) {
            setKeys(Object.keys(transactions[firstKey][0]));
        } else {
            setKeys([]);
        }
    }, [transactions]);

    useEffect(() => {
        setColumns(keys.map(key => ({
            Header: key.charAt(0).toUpperCase() + key.slice(1),
            accessor: key,
        })));
    }, [keys]);

    const handleFilter = () => {
        const url = `${BASE_URL}${PATH_REPORT}?first_date=${filterFirstDate}&last_date=${filterLastDate}`;
        fetchData(url).then((res) => setData(res || []));
    };

    const [loadingRows, setLoadingRows] = useState({});

    const handleToggle = async (code, type) => {
        setExpandedAccounts(prev => ({ ...prev, [code]: !prev[code] }));

        // if (!transactions[code]) {
            setLoadingRows(prev => ({ ...prev, [code]: true }));
            try {
                const url = `${BASE_URL}${PATH_REPORT}/transactions?type_account=${type}&code_account=${code}&first_date=${filterFirstDate}&last_date=${filterLastDate}`;
                const res = await axios.get(url);
                setTransactions(prev => ({ ...prev, [code]: res.data }));
            } catch (err) {
                console.error("Failed to fetch transactions", err);
            } finally {
                setLoadingRows(prev => ({ ...prev, [code]: false }));
            }
        // }
    };

    if (error) return <div className="text-red-500">{error}</div>;

    return (
        <div className="p-4">
            <h1 className="text-lg font-bold mb-4">Laporan Buku Besar</h1>

            {/* Filters */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-4">
                <div>
                    <label className="block mb-1 text-sm font-semibold">Tanggal Awal</label>
                    <input
                        type="date"
                        value={filterFirstDate}
                        onChange={(e) => setFilterFirstDate(e.target.value)}
                        className="w-full p-2 border rounded"
                    />
                </div>
                <div>
                    <label className="block mb-1 text-sm font-semibold">Tanggal Akhir</label>
                    <input
                        type="date"
                        value={filterLastDate}
                        onChange={(e) => setFilterLastDate(e.target.value)}
                        className="w-full p-2 border rounded"
                    />
                </div>
                <div className="flex items-end">
                    <button
                        onClick={handleFilter}
                        className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
                    >
                        Filter
                    </button>
                </div>
            </div>

            {/* Data Display */}
            {loading ? (
                <p className="text-center">Loading...</p>
            ) : (
                data.map((section, i) => (
                    <div key={i} className="mb-6">
                        <h2 className="text-md font-semibold mb-2">{section.label}</h2>
                        {section.data.map((group, j) => (
                            <div key={j} className="mb-4">
                                <h3 className="text-sm font-medium mb-2">{group.label}</h3>
                                <table className="w-full border text-sm mb-2">
                                    <thead className="bg-gray-100">
                                        <tr>
                                            <th className="border px-2 py-1 text-left">Code</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {group.data.map((item, k) => (
                                            <React.Fragment key={k}>
                                                <tr>
                                                    <td
                                                        onClick={() => handleToggle(item.code, item.type)}
                                                        className="border px-2 py-2 cursor-pointer bg-gray-50 hover:bg-gray-100"
                                                    >
                                                        {item.code} - {item.name}
                                                    </td>
                                                </tr>
                                                {expandedAccounts[item.code] && (
                                                    <tr>
                                                        <td colSpan={1} className="p-0">
                                                            <div className="bg-white px-4 py-2 border-t">
                                                                {loadingRows[item.code] ? (
                                                                    <p className="text-sm text-gray-500">Loading transactions...</p>
                                                                ) : transactions[item.code] ? (
                                                                    <DataTableDynamic
                                                                        data={transactions[item.code]}
                                                                        columns={columns}
                                                                        moduleActions={[]}
                                                                        enableCustom={false}
                                                                    />
                                                                ) : null}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ))}
                    </div>
                ))
            )}
        </div>
    );
};

export default ReportGeneralLedger;